module.exports = __webpack_public_path__ + "assets/img/Profiting_002.c8fe9dfb.svg";